import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { useSelector } from "react-redux";
import _ from "lodash";
import smartParkService from "../../axios";
import { login_ } from "../../reducers/login";
import { KeyboardArrowDown, KeyboardArrowRight } from "@material-ui/icons";
import {
  MenuItem,
  Select,
  FormControl,
  Grid,
  Typography,
  ListSubheader,
  Checkbox,
} from "@material-ui/core";

export default function ReportsOptions({
  searchHandler = () => {
    console.log("no function");
  },
  options,
}) {
  const loginDetails = useSelector(login_);
  const userid = _.get(loginDetails, ["UserID"], "");
  const [fetchData, setFetchData] = useState(false);
  const [showOptions, setShowOptions] = useState(true);
  const [deviceOptions, setDeviceOptions] = useState({});
  const [finalOptions, setFinalOptions] = useState();
  const [aggregationOptions, setAggregationOptions] = useState({});
  const [samplingPeriodOptions, setSamplingPeriodOptions] = useState({});

  const [sensorOptions, setSensorOptions] = useState({
    device: "",
    sensors: [],
    samplingPeriod: "",
    aggregationMethod: "",
  });

  const refreshOptions = ({ device, sensors, samplingperiod, aggregation }) => {
    const opt = {};
    const samplingPeriodOptions = options[device]["SamplingOptions"];
    const aggregationOptions = options[device]["AggregationMethods"];
    Object.values(deviceOptions[device]).map((sensor) => {
      if (!opt[sensor.parkName]) {
        opt[sensor.parkName] = [];
      }
      opt[sensor.parkName].push(sensor);
    });
    setSensorOptions({
      device: device,
      sensors: sensors,
      samplingPeriod: samplingperiod || Object.values(samplingPeriodOptions)[0],
      aggregationMethod: aggregation || Object.values(aggregationOptions)[0],
    });
    setSamplingPeriodOptions(samplingPeriodOptions);
    setAggregationOptions(aggregationOptions);
    setFinalOptions(opt);
  };

  const initialState = () => {
    const samplingPeriodOptions =
      options[Object.keys(deviceOptions)[0]]["SamplingOptions"];
    const AggregationMethods =
      options[Object.keys(deviceOptions)[0]]["AggregationMethods"];

    setSamplingPeriodOptions(samplingPeriodOptions);
    setAggregationOptions(AggregationMethods);

    refreshOptions({
      device: Object.keys(deviceOptions)[0],
      sensors: Object.keys(deviceOptions[Object.keys(deviceOptions)[0]]),
      samplingperiod: Object.values(samplingPeriodOptions)[0],
      aggregation: Object.values(AggregationMethods)[0],
    });
  };
  // useEffect(() => {
  //   if (Object.entries(deviceOptions).length > 0) {
  //     refreshDeviceOptions();
  //   }
  // }, [sensorOptions.device]);

  const fetch = () => {
    setFetchData(true);
    setTimeout(() => {
      setFetchData(false);
    }, 2000);
  };

  const fetchOptions = () => {
    let url = "/api/report/options";
    var restoken = "citizen";
    smartParkService
      .get(url, {
        headers: {
          "x-access-token": restoken,
          userid: "bbeafa0d-6c40-4f93-bac1-17f39d86650e",
        },
      })
      .then((res) => {
        if (res) {
          const deviceData = {};
          Object.values(res.data?.dropdown).forEach((park) => {
            Object.entries(park.Devices).forEach(([type, devices]) => {
              if (Object.keys(options).includes(type)) {
                deviceData[type] = deviceData[type] || {};
                devices.forEach((device) => {
                  if (!deviceData[type][device.SensorID]) {
                    deviceData[type][device.SensorID] = {
                      ...device,
                      parkId: park.ID,
                      parkName: park.Name,
                      short_name: park.ShortName,
                      total_count: device.SensorTotalCount || null,
                    };
                  }
                });
              }
            });
          });
          setDeviceOptions(deviceData);
        }
      });
  };
  useEffect(() => {
    fetchOptions();
  }, []);

  useEffect(() => {
    if (
      Object.keys(deviceOptions).length > 0 &&
      Object.keys(options).length > 0
    ) {
      fetch();
      initialState();
    }
  }, [deviceOptions]);

  useEffect(() => {
    if (fetchData) {
      searchHandler(sensorOptions, deviceOptions);
    }
  }, [sensorOptions]);

  return (
    <div style={{ padding: "10px 20px" }}>
      <div className="searchlogging">
        <div>
          <div className="row">
            <div className="col-12 logmobilepadd">
              <Card border="info" className="my-2 searchcard">
                <Card.Header>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Report Options</div>
                    <div
                      onClick={() => {
                        setShowOptions((r) => !r);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {showOptions ? (
                        <KeyboardArrowDown />
                      ) : (
                        <KeyboardArrowRight />
                      )}
                    </div>
                  </div>
                </Card.Header>

                {showOptions && (
                  <Card.Body>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={4}>
                            <Typography variant="h6" gutterBottom>
                              Device Type:
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <FormControl variant="outlined" fullWidth>
                              <Select
                                value={sensorOptions.device}
                                onChange={(e) => {
                                  refreshOptions({
                                    device: e.target.value,
                                    sensors: [],
                                    aggregation: "",
                                    samplingperiod: "",
                                  });
                                }}
                                displayEmpty
                              >
                                {Object.keys(deviceOptions).map(
                                  (type, index) => {
                                    return (
                                      <MenuItem value={type} key={index}>
                                        {type}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={4}>
                            <Typography variant="h6" gutterBottom>
                              Device Name:
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <FormControl variant="outlined" fullWidth>
                              <Select
                                value={sensorOptions.sensors || []}
                                displayEmpty
                                renderValue={(selected) => {
                                  if (selected.length === 0)
                                    return <em>Select Sensors</em>;

                                  const selectedSensors = selected.map(
                                    (sensorId) => {
                                      if (
                                        deviceOptions[sensorOptions.device] &&
                                        deviceOptions[sensorOptions.device][
                                          sensorId
                                        ]
                                      ) {
                                        return deviceOptions[
                                          sensorOptions.device
                                        ][sensorId].SensorName;
                                      }
                                      return sensorId;
                                    }
                                  );
                                  return selectedSensors.join(", ");
                                }}
                              >
                                {finalOptions &&
                                  Object.entries(finalOptions).map(
                                    ([parkName, sensors]) => {
                                      return (
                                        <React.Fragment key={parkName}>
                                          <ListSubheader
                                            style={{
                                              borderBottom: "1px solid black",
                                              fontWeight: 600,
                                              color: "black",
                                              fontSize: 16,
                                            }}
                                          >
                                            {parkName}
                                          </ListSubheader>
                                          {sensors.map((sensor) => (
                                            <MenuItem
                                              key={sensor.SensorID}
                                              value={sensor.SensorID}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Checkbox
                                                checked={sensorOptions.sensors.includes(
                                                  sensor.SensorID
                                                )}
                                                style={{
                                                  color: "#015fb9",
                                                  marginRight: 8,
                                                }}
                                                onClick={(event) => {
                                                  if (event.target.checked) {
                                                    setSensorOptions({
                                                      ...sensorOptions,
                                                      sensors: [
                                                        ...sensorOptions.sensors,
                                                        sensor.SensorID,
                                                      ],
                                                    });
                                                  } else {
                                                    setSensorOptions({
                                                      ...sensorOptions,
                                                      sensors: [
                                                        ...sensorOptions.sensors.filter(
                                                          (sensorId) =>
                                                            sensorId !==
                                                            sensor.SensorID
                                                        ),
                                                      ],
                                                    });
                                                  }
                                                }}
                                              />
                                              {sensor.SensorName}
                                            </MenuItem>
                                          ))}
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                              </Select>
                            </FormControl>
                            {/* <FormControl variant="outlined" fullWidth>
                                <Select
                                  value={sensorOptions.sensors}
                                  multiple
                                  onChange={(e) => {
                                    setSensorOptions((prev) => {
                                      return {
                                        ...prev,
                                        sensors: e.target.value,
                                      };
                                    });
                                  }}
                                  displayEmpty
                                >
                                  {sensorOptions.device &&
                                    Object.entries(deviceOptions).length > 0 &&
                                    Object.entries(
                                      deviceOptions[sensorOptions.device]
                                    ).map(([option, v], index) => {
                                      return (
                                        <MenuItem key={option} value={option}>
                                          {v.SensorName}
                                        </MenuItem>
                                      );
                                    })}
                                </Select>
                              </FormControl> */}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={4}>
                            <Typography variant="h6" gutterBottom>
                              Aggregation Method:
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <FormControl variant="outlined" fullWidth>
                              <Select
                                value={sensorOptions.aggregationMethod}
                                onChange={(e) => {
                                  setSensorOptions((prev) => {
                                    return {
                                      ...prev,
                                      aggregationMethod: e.target.value,
                                    };
                                  });
                                }}
                                displayEmpty
                              >
                                {Object.entries(aggregationOptions).map(
                                  ([key, value], index) => {
                                    return (
                                      <MenuItem key={value} value={value}>
                                        {key}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={4}>
                            <Typography variant="h6" gutterBottom>
                              Sampling Period :
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <FormControl variant="outlined" fullWidth>
                              <Select
                                value={sensorOptions.samplingPeriod}
                                onChange={(e) => {
                                  setSensorOptions((prev) => {
                                    return {
                                      ...prev,
                                      samplingPeriod: e.target.value,
                                    };
                                  });
                                }}
                                displayEmpty
                              >
                                {Object.entries(samplingPeriodOptions).map(
                                  ([k, v], index) => {
                                    return (
                                      <MenuItem key={v} value={v}>
                                        {k}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <div className="row mt-1">
                      <div className="col-12 col-md-12 spacebet logbtnleftright">
                        <button
                          type="button"
                          disabled={
                            !sensorOptions.aggregationMethod ||
                            !sensorOptions.samplingPeriod ||
                            sensorOptions.sensors.length < 1
                          }
                          className="btn  mr-2 logSearchbtn"
                          onClick={() => {
                            fetch();
                            searchHandler(sensorOptions, deviceOptions);
                          }}
                        >
                          Generate Report
                        </button>
                        <button
                          type="button"
                          className="btn logcancelbtn"
                          onClick={() => {
                            initialState();
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Card.Body>
                )}
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
